import React, { useState } from "react";

function BookingGstInfo() {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  return (
    <section className="info-section">
      {/* Booking Section */}
      <div className="info-row">
      <div className="info-section-title">
        <h2>Booking Options</h2>
      </div>
        <div className="info-image">
          <img src="/images/Booking_info.webp" alt="Booking Illustration" />
        </div>
        <div className="info-text">
          <div className="booking-card">
            <div className="info-card service-description">
                <div className="info-icon">
                    <img src="/images/Booking-paid.webp" alt="Paid Booking"></img>
                </div>
                <div>
                <strong>Paid Booking</strong>
                <p> Where the consignor pays at the point of booking the consignment.</p>
                </div>
            </div>
            <div className="info-card service-description">
                <div className="info-icon">
                    <img src="/images/to-pay_1.webp" alt="Paid Booking"></img>
                </div>
                <div>
                <strong>To-pay Booking</strong>
                <p> The consignor books without paying; the consignee pays at delivery.</p>
                </div>
            </div>
            <div className="info-card service-description">
                <div className="info-icon">
                    <img src="/images/to_be_paid.webp" alt="Paid Booking"></img>
                </div>
                <div>
                <strong>To Be Billed</strong>
                <p> For regular customers with account-based billing and credit periods.</p>
                </div>
            </div>
            <div className="info-card service-description">
                <div className="info-icon">
                    <img src="/images/door-collection.webp" alt="Paid Booking"></img>
                </div>
                <div>
                <strong>Door Collections</strong>
                <p> Consignments are regularly collected from the consignor’s address as per instruction, with a minimal door collection fee.</p>
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* GST Section */}
      <div className="info-row">
      <div className="info-section-title">
        <h2>GST Service Details</h2>
      </div>
      <div className="info-text">
        <div className="booking-card">
          <div className="info-card service-description">
            <div className="info-icon">
              <img src="/images/GST-code.webp" alt="GST Code" />
            </div>
            <div>
              <strong>GST Service Code</strong>
              <p>We are registered under GST Service Code 996791.</p>
            </div>
          </div>
          <div className="info-card service-description">
            <div className="info-icon">
              <img src="/images/question-mark.webp" alt="How to Pay GST" />
            </div>
            <div>
              <strong>How To Pay GST</strong>
              <p>GST is paid under reverse charge; we do not collect GST in our LRs.</p>
            </div>
          </div>
          <div className="info-card service-description">
            <div className="info-icon">
              <img src="/images/Exempt.webp" alt="GST Exemptions" />
            </div>
            <div>
            <div>
              <strong>Exempted List</strong>
              <p>Agricultural produce
              Milk, Salt, and food grains</p>
              <button onClick={openModal} className="more-btn">+ View all exemptions</button>
              {showModal && (
                <div className="modal-overlay" onClick={closeModal}>
                  <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <h3>Complete Exempted List</h3>
                    <ul className="exempt-list">
                      <li>Agricultural produce</li>
                      <li>Organic manure</li>
                      <li>Milk, Salt, and food grains (flour, pulses, rice)</li>
                      <li>Registered newspapers or magazines</li>
                      <li>Relief materials for disasters or accidents</li>
                      <li>Defense or military equipment</li>
                      <li>Freight charge less than ₹750</li>
                      <li>Customers not liable to pay GST</li>
                      <li>Unregistered GST customers</li>
                    </ul>
                    <button className="close-btn" onClick={closeModal}>Close</button>
                  </div>
                </div>
              )}
            </div>
            </div>
          </div>
          <div className="info-card service-description">
            <div className="info-icon">
              <img src="/images/GST-ID.webp" alt="GST Numbers" />
            </div>
            <div>
              <strong>Our GST Numbers</strong>
              <ul>
                <li>
                <strong>Karnataka:</strong> 29ADGPN1390R2ZR
                </li>
                <li>
                <strong>Tamil Nadu:</strong> 33ADGPN1390R1Z3
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="info-image">
        <img src="/images/gst_info.webp" alt="GST Illustration" />
      </div>
    </div>
    {/* Banned Goods */}

    <div className="info-row">
    <div className="info-section-title">
        <h2>Banned Goods</h2>
      </div>
      <div className="info-image">
        <img src="/images/banned-goods-1.webp" alt="Banned Goods Illustration" />
      </div>

      <div className="info-text">
        <ul className="banned-goods-list">
          <li>Explosives, Crackers, RDX, Bullets</li>
          <li>Liquor, Spirit, Acid, Phosphorus</li>
          <li>Matchboxes, Jaggery, Cardamom, Kadukkai</li>
          <li>Sandalwood, Forest Produce, Gas Cylinders</li>
          <li>Country Drugs, Uranium, Weapons, Khanja</li>
          <li>Rationed Goods, Other Contraband Items</li>
          <li>All goods banned by the Government of India</li>
        </ul>
      </div>
    </div>

    </section>
  );
}

export default BookingGstInfo;
